module.exports = __webpack_public_path__ + "static/media/Arrow.8a6b888a.svg";